/* eslint-disable no-restricted-globals */
import React, { useState } from 'react';
import './styles.scss';
import { FaBars } from 'react-icons/fa';
import EpimedLogo from '../../assets/img/Logo_Epimed.svg';
import EpAvatarDropdown from '../EpAvatarDropdown';
import EpButton from '../EpButton';
import useTranslation from '../../hooks/useTranslation';
// import LinkNavigation from '../LinkNavigation';

const EpGlobalNavigation = () => {
  // Tags do Globalization
  const EpimedSystemIntegration = useTranslation('Epimed Monitor Integration');
  const Integrations = useTranslation('Integrations');

  const productName = EpimedSystemIntegration;
  const [isSelected, setIsSelected] = useState(true);

  return (
    <header id="navigation--global">
      <div className="ep__container">

        <nav className="navbar-expand-md navbar-light navigation">

          <EpButton
            customClass="navbar-toggler navigation__btn-mobile"
            actionType="button"
            dataBsToggle="collapse"
            dataBsTarget="#navbarSupportedContent"
            ariaControls="navbarSupportedContent"
            ariaExpanded="false"
            buttonIcon={<FaBars />}
          />

          <div className="navigation__brand-logo">
            <img
              className="navigation__brand-logo-image"
              src={EpimedLogo}
              alt="Epimed logo"
            />
          </div>

          <div className="navigation__product-name">
            <h1 className="navigation__product-name-title">{productName} »</h1>
          </div>

          <EpAvatarDropdown avatarMenuId="navigation__avatar-dropdown" avatarContainerId="navigation__avatar-dropdown-mobile" />

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav navigation__list">
              <li
                className="navigation__list-item"
              >
                <EpButton
                  isActive={isSelected}
                  labelText={Integrations}
                  actionType="button"
                  buttonType="link-nav-primary"
                  linkFunc={() => setIsSelected(true)}
                  customClass="navigation__list-item-link"
                  size="sm"
                />
              </li>
            </ul>
          </div>

          <EpAvatarDropdown avatarMenuId="navigation__avatar-dropdown" avatarContainerId="navigation__avatar-dropdown-desktop" />
        </nav>

      </div>
      <div className="navigation__product-mobile-name" id="navigation__product-mobile-name">
        <h1 className="navigation__product-mobile-name-title" id="navigation__product-mobile-name-title">{productName} »</h1>
      </div>
    </header>

  );
};

export default EpGlobalNavigation;
